import { render, staticRenderFns } from "./RecentEvents.vue?vue&type=template&id=281241e8&scoped=true&"
import script from "./RecentEvents.vue?vue&type=script&lang=js&"
export * from "./RecentEvents.vue?vue&type=script&lang=js&"
import style0 from "./RecentEvents.vue?vue&type=style&index=0&id=281241e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281241e8",
  null
  
)

export default component.exports